const getAssetPath = (imageName) => {
  const localImage = require(`../assets/images/${imageName}`);
  return `${window.location.origin}/${localImage}`;
};

const hubLogo = getAssetPath('hubLogo.svg');
const welcomeScreen = getAssetPath('welcome-screen.svg');

const Images = {
  welcomeScreen,
  hubLogo,
};

export default Images;
